import { forwardRef, type ReactNode } from 'react';
import { When } from 'react-if';
import { type QuizGenerateItem } from '@/api/ai/type';
import { type GenerateStatus } from '@/shared/features/ai-quiz-generation/types';
import { type AchievementStandard } from '../../../ai-quiz-generation/hooks/types';
import { BuildAiGeneratedResultContainer } from './BuildAiGeneratedResultContainer';
import { BuildAiGeneratedResultItem } from './BuildAiGeneratedResultItem';
import { BuildAiGeneratedResultItemSkeleton } from './BuildAiGeneratedResultItemSkeleton';
interface BuildAiGeneratedResultProps {
  resultDescription: ReactNode;
  selectedItems: QuizGenerateItem[];
  savedItems: QuizGenerateItem[];
  unSavedItems: QuizGenerateItem[];
  onSelect: (item: QuizGenerateItem) => void;
  onSelectAll: () => void;
  onDelete?: (item: QuizGenerateItem) => void;
  skeletonCount?: number;
  status?: GenerateStatus;
  className?: string;
  selectedAchievementStandards: AchievementStandard[];
}
export const BuildAiGeneratedResult = forwardRef<HTMLDivElement, BuildAiGeneratedResultProps>(({
  resultDescription,
  selectedItems,
  savedItems,
  unSavedItems,
  onSelect,
  onSelectAll,
  onDelete,
  skeletonCount = 0,
  status = 'idle',
  className,
  selectedAchievementStandards
}, ref) => {
  return <BuildAiGeneratedResultContainer ref={ref} resultDescription={resultDescription} selectedItemsCount={selectedItems.length} onSelectAll={onSelectAll} status={status} className={className}>
        <When condition={status === 'regenerating'}>
          {Array.from({
        length: skeletonCount
      }).map((_, index) => <BuildAiGeneratedResultItemSkeleton key={`skeleton-${index}`} />)}
        </When>
        {unSavedItems.map((item, index) => <BuildAiGeneratedResultItem mappedStandards={selectedAchievementStandards.filter(standard => item.standard?.includes(standard.code))} key={`unsaved-${index}-${item.question}`} item={item} isSelected={selectedItems.includes(item)} onSelect={() => onSelect(item)} onDelete={onDelete ? () => onDelete(item) : undefined} />)}
        {savedItems.map((item, index) => <BuildAiGeneratedResultItem mappedStandards={selectedAchievementStandards.filter(standard => item.standard?.includes(standard.code))} key={`saved-${index}-${item.question}`} item={item} isSelected={selectedItems.includes(item)} onSelect={() => onSelect(item)} isSaved={true} />)}
      </BuildAiGeneratedResultContainer>;
});
BuildAiGeneratedResult.displayName = 'BuildAiGeneratedResult';